// @flow

import { useContext } from 'react';
import useEnabledFeature from '../../useEnabledFeature/useEnabledFeature';
import { BreakpointContext, XLARGE } from '@core-ui/breakpoint-provider';

const useBottomProductBreadcrumbs = (): boolean => {
  const { greaterOrEqualTo } = useContext(BreakpointContext);
  return useEnabledFeature('bottom-product-breadcrumbs') && greaterOrEqualTo(XLARGE);
};

export default useBottomProductBreadcrumbs;
